import { useState } from 'react';

const useSnackbar = () => {
    const [snackbar, setSnackbar] = useState({ 
        isOpen: false, 
        message: '', 
        type: 'success' 
    });

    const showSnackbar = (message, type = 'success') => {
        setSnackbar({ isOpen: true, message, type });
        
        setTimeout(() => {
        setSnackbar(prev => ({ ...prev, isOpen: false }));
        }, 2000);
    };

    const closeSnackbar = () => {
        setSnackbar(prev => ({ ...prev, isOpen: false }));
    };

    return {
        snackbar,
        showSnackbar,
        closeSnackbar
    };
};

export default useSnackbar;
